module.exports = __webpack_public_path__ + "img/11.d934b75a.jpg";